import {CSSProperties} from "react";
import {Tooltip} from "@mui/material";
import BooleanInput from "./booleanInput.element";
import {useFieldDoc} from "./useFieldDoc";

interface BooleanInputLabelProps {
    // Optional: omitted when `field` supplies the label from the model's [FieldDoc].
    title?: string;
    value: boolean;
    tooltip?: string;
    // Manifest field key — sources the label + tooltip from the Client model.
    field?: string;
    inputStyle?: CSSProperties;
    onChange(value: boolean): void;
}

function BooleanInputLabel(props: BooleanInputLabelProps) {
    const {label, tip} = useFieldDoc({field: props.field, title: props.title, tooltip: props.tooltip});
    return (
        <div className={'layout horizontal stretch gap'} style={{alignItems: 'center', gap: 10}}>
            {tip
                ? <Tooltip title={tip} arrow disableInteractive>
                    <p style={{cursor: 'help'}}>{label}</p>
                </Tooltip>
                : <p>{label}</p>}
            <BooleanInput value={props.value} style={props.inputStyle} onChange={props.onChange}/>
        </div>
    )
}

export default BooleanInputLabel;
